module.exports = __webpack_public_path__ + "img/20.7116d243.png";